export function DeskSidebarIcon({ ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" {...props}>
      <g id="Group_24488" data-name="Group 24488" transform="translate(-865 -172)">
        <g
          id="Rectangle_10299"
          data-name="Rectangle 10299"
          transform="translate(865 172)"
          fill="#fff"
          stroke="currentColor"
          strokeWidth="1"
          opacity="0"
        >
          <rect width="24" height="24" stroke="none" />
          <rect x="0.5" y="0.5" width="23" height="23" fill="none" />
        </g>
        <path
          id="Path_41468"
          data-name="Path 41468"
          d="M2889.2,1197.7l-2.772,2.8c-.378.4-.576.594-.738.6a.455.455,0,0,1-.378-.153c-.108-.126-.108-.405-.108-.954v-1.4a.968.968,0,0,0-.891-.918h0a2.692,2.692,0,0,1-2.286-2.286,7.113,7.113,0,0,1-.027-.891v-4.176a6.64,6.64,0,0,1,.3-2.844,2.581,2.581,0,0,1,1.179-1.179,6.641,6.641,0,0,1,2.844-.3h6.66a6.642,6.642,0,0,1,2.844.3,2.581,2.581,0,0,1,1.179,1.179,6.64,6.64,0,0,1,.3,2.844v3.78m0,9.9-1.962-1.359a3.769,3.769,0,0,0-.558-.36,2.2,2.2,0,0,0-.414-.126,3.183,3.183,0,0,0-.666-.036h-1.62a4.645,4.645,0,0,1-1.9-.189,1.847,1.847,0,0,1-.783-.792,4.449,4.449,0,0,1-.2-1.9v-2.259a4.449,4.449,0,0,1,.2-1.9,1.826,1.826,0,0,1,.783-.783,4.449,4.449,0,0,1,1.9-.2h5.04a4.448,4.448,0,0,1,1.9.2,1.828,1.828,0,0,1,.783.783,4.449,4.449,0,0,1,.2,1.9v2.439a4.565,4.565,0,0,1-.135,1.593,1.8,1.8,0,0,1-.972.972,4.593,4.593,0,0,1-1.593.135Z"
          transform="translate(-2014 -1011)"
          fill="rgba(0,0,0,0)"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.64"
        />
      </g>
    </svg>
  );
}
